import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_9162_14601",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 17,
		height: 17,
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_9162_14601)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M-4 0.000249206H20.9997V17H-4V0.000249206Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.2172 11.4563L20.9997 17V15.4321L13.9836 11.4563H11.2172Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.78252 5.54336L-4 0.000249206V1.56755L3.01619 5.54336H5.78252Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.0624 0H6.93739V6.90604H-4V10.0935H6.93739V16.9995H10.0624V10.0935H20.9997V6.90604H10.0624V0Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2278 11.4562L21 14.7271V11.4562H15.2278ZM11.2172 11.4563L20.9997 17V15.4321L13.9836 11.4563H11.2172ZM18.3943 16.9995L11.2175 12.9324V16.9995H18.3943Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.2172 11.4563L20.9997 17V15.4321L13.9836 11.4563H11.2172Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.411138 11.456L-4 13.9557V11.456H0.411138ZM5.78252 12.161V16.9994H-2.75533L5.78252 12.161Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.01619 11.4562L-4 15.432L-4 17L5.78252 11.4562H3.01619Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.77216 5.54332L-4 2.27243V5.54332H1.77216ZM5.78252 5.54336L-4 0.000249206V1.56755L3.01619 5.54336H5.78252ZM-1.39426 0L5.78252 4.06715V0H-1.39426Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.78252 5.54336L-4 0.000249206V1.56755L3.01619 5.54336H5.78252Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.5889 5.54337L21 3.04374V5.54337H16.5889ZM11.2175 4.83845V0H19.7553L11.2175 4.83845Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.9838 5.54332L21 1.56751L20.9997 0.000249206L11.2175 5.54332H13.9838Z",
				fill: "#D80027"
			})
		]
	})]
});
export default SvgEn;
